import { render } from "./PdfSlides.vue?vue&type=template&id=2a10ed10&scoped=true"
import script from "./PdfSlides.vue?vue&type=script&lang=js"
export * from "./PdfSlides.vue?vue&type=script&lang=js"

import "./PdfSlides.vue?vue&type=style&index=0&id=2a10ed10&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a10ed10"]])

export default __exports__